import React from "react";
import  ReactDOM from "react-dom/client"; //Changed in version 18 of React
 
import App from "./App";
import "./index.css";
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<App />);